import { useEffect } from "react";
import { Link } from "react-router-dom";

export default function TermsOfService() {
  useEffect(() => {
    window.scrollTo(0, 0);
  }, []);

  return (
    <div className="min-h-screen bg-white" style={{ fontFamily: "'Inter', sans-serif" }}>
      {/* Header */}
      <header className="w-full bg-stone-900 text-white">
        <div className="max-w-5xl mx-auto px-6 py-5 flex items-center justify-between">
          <Link
            to="/"
            className="flex items-center gap-3 cursor-pointer hover:opacity-80 transition-opacity"
          >
            <img
              src="https://static.readdy.ai/image/44752aaa2b8c60b6ac39ccbed2793a85/f0377fb5ec1076e4cb9e676fd4f0df74.jpeg"
              alt="Coliving HIDA TAKAYAMA"
              className="w-9 h-9 rounded-full object-cover"
            />
            <span
              className="text-base tracking-widest font-light"
              style={{ fontFamily: "'Noto Serif JP', serif" }}
            >
              COLIVING HIDA TAKAYAMA
            </span>
          </Link>
          <Link
            to="/"
            className="text-sm text-gray-300 hover:text-orange-400 transition-colors cursor-pointer flex items-center gap-1"
          >
            <i className="ri-arrow-left-line w-4 h-4 flex items-center justify-center"></i>
            Back to Home
          </Link>
        </div>
      </header>

      {/* Main Content */}
      <main className="max-w-5xl mx-auto px-6 py-16">
        <h1
          className="text-2xl font-semibold text-stone-800 mb-2"
          style={{ fontFamily: "'Noto Serif JP', serif" }}
        >
          Coliving HIDA TAKAYAMA Terms of Service
        </h1>
        <p className="text-sm text-gray-500 mb-10">
          These Terms of Service (the "Terms") govern the use of "Coliving HIDA TAKAYAMA" (the "Facility") operated by NPO MOSHIMOSHI (the "NPO").
        </p>

        <div className="space-y-10">
          {/* Article 1 */}
          <section>
            <h2 className="text-xl font-semibold text-stone-800 mb-4 flex items-center">
              <span className="w-8 h-8 flex items-center justify-center bg-orange-400 text-white rounded-full text-sm mr-3">1</span>
              Article 1 (Applicability)
            </h2>
            <div className="pl-11 text-stone-600 leading-relaxed space-y-2">
              <p>These Terms apply to all users (the "User") of the Facility. By applying to use the Facility, the User is deemed to have agreed to these Terms.</p>
            </div>
          </section>

          {/* Article 2 */}
          <section>
            <h2 className="text-xl font-semibold text-stone-800 mb-4 flex items-center">
              <span className="w-8 h-8 flex items-center justify-center bg-orange-400 text-white rounded-full text-sm mr-3">2</span>
              Article 2 (Contract and Period)
            </h2>
            <div className="pl-11 text-stone-600 leading-relaxed space-y-3">
              <p>The Facility is a residential space intended for long-term stays of one month or longer. Short-term stays (less than one month) are not permitted.</p>
              <p>Users must execute a contract via the method designated by the NPO (e.g., DocuSign) and submit identity verification documents (e.g., passport).</p>
            </div>
          </section>

          {/* Article 3 */}
          <section>
            <h2 className="text-xl font-semibold text-stone-800 mb-4 flex items-center">
              <span className="w-8 h-8 flex items-center justify-center bg-orange-400 text-white rounded-full text-sm mr-3">3</span>
              Article 3 (Fees and Payment)
            </h2>
            <div className="pl-11 text-stone-600 leading-relaxed space-y-3">
              <p>All fees (Rent, Common area fees, Initial costs, etc.) must be paid in full in advance via credit card.</p>
              <p>Payments are processed through Stripe. A reservation is confirmed only after the NPO verifies the payment.</p>
              <p>Fees are tax-exempt as they constitute residential rent.</p>
            </div>
          </section>

          {/* Article 4 */}
          <section>
            <h2 className="text-xl font-semibold text-stone-800 mb-4 flex items-center">
              <span className="w-8 h-8 flex items-center justify-center bg-orange-400 text-white rounded-full text-sm mr-3">4</span>
              Article 4 (Prohibited Acts)
            </h2>
            <div className="pl-11 text-stone-600 leading-relaxed">
              <p className="mb-3">Users shall not engage in the following acts within the Facility:</p>
              <ul className="space-y-2">
                <li className="flex items-start">
                  <span className="mt-1.5 w-1.5 h-1.5 rounded-full bg-orange-400 shrink-0 mr-3"></span>
                  <span>Smoking inside the rooms or any part of the premises.</span>
                </li>
                <li className="flex items-start">
                  <span className="mt-1.5 w-1.5 h-1.5 rounded-full bg-orange-400 shrink-0 mr-3"></span>
                  <span>Activities that cause noise, odors, or any disturbance to neighbors or other users.</span>
                </li>
                <li className="flex items-start">
                  <span className="mt-1.5 w-1.5 h-1.5 rounded-full bg-orange-400 shrink-0 mr-3"></span>
                  <span>Sub-letting the Facility or allowing third parties to stay overnight.</span>
                </li>
                <li className="flex items-start">
                  <span className="mt-1.5 w-1.5 h-1.5 rounded-full bg-orange-400 shrink-0 mr-3"></span>
                  <span>Any illegal acts or acts contrary to public order and morals.</span>
                </li>
              </ul>
            </div>
          </section>

          {/* Article 5 */}
          <section>
            <h2 className="text-xl font-semibold text-stone-800 mb-4 flex items-center">
              <span className="w-8 h-8 flex items-center justify-center bg-orange-400 text-white rounded-full text-sm mr-3">5</span>
              Article 5 (Cancellation and Termination)
            </h2>
            <div className="pl-11 text-stone-600 leading-relaxed space-y-3">
              <p>Due to the nature of the service, no refunds will be provided after the service has started.</p>
              <p>For stays exceeding one month, the User must submit a termination request at least 10 days prior to the intended move-out date.</p>
            </div>
          </section>

          {/* Article 6 */}
          <section>
            <h2 className="text-xl font-semibold text-stone-800 mb-4 flex items-center">
              <span className="w-8 h-8 flex items-center justify-center bg-orange-400 text-white rounded-full text-sm mr-3">6</span>
              Article 6 (Disclaimer)
            </h2>
            <div className="pl-11 text-stone-600 leading-relaxed space-y-3">
              <p>The NPO is not liable for any loss, theft of personal belongings, or disputes between users within the Facility.</p>
              <p>The NPO shall not be held responsible for any temporary suspension of services due to unexpected internet outages or equipment failure.</p>
            </div>
          </section>

          {/* Article 7 */}
          <section>
            <h2 className="text-xl font-semibold text-stone-800 mb-4 flex items-center">
              <span className="w-8 h-8 flex items-center justify-center bg-orange-400 text-white rounded-full text-sm mr-3">7</span>
              Article 7 (Governing Law and Jurisdiction)
            </h2>
            <div className="pl-11 text-stone-600 leading-relaxed space-y-3">
              <p>These Terms shall be governed by and construed in accordance with the laws of Japan. Any disputes arising out of these Terms shall be subject to the exclusive jurisdiction of the Gifu District Court.</p>
            </div>
          </section>
        </div>

        <div className="mt-12 text-center">
          <Link
            to="/"
            className="inline-flex items-center gap-2 text-sm text-stone-500 hover:text-orange-500 transition-colors cursor-pointer"
          >
            <i className="ri-arrow-left-line w-4 h-4 flex items-center justify-center"></i>
            Back to Home
          </Link>
        </div>
      </main>

      {/* Footer */}
      <footer className="bg-stone-100 border-t border-gray-200">
        <div className="max-w-5xl mx-auto px-6 py-8 text-center text-xs text-gray-400">
          &copy; {new Date().getFullYear()} NPO MOSHIMOSHI. All rights reserved.
          <span className="mx-2">•</span>
          <a
            href="https://readdy.ai/?ref=logo"
            rel="nofollow"
            className="hover:text-orange-500 transition-colors cursor-pointer"
          >
            Powered by Readdy
          </a>
        </div>
      </footer>
    </div>
  );
}
